import { logUserAction } from '@office-start/telemetry-service';
export var logTagAction = function (area, id, result, tagColor) {
    logUserAction({
        eventName: 'TagAction',
        id: id,
        area: area,
        result: result,
        target: 'HarmonyTag',
        targetId: tagColor,
    });
};
//# sourceMappingURL=logTagAction.js.map